import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import {
  UpdateFavoriteProductRequest,
  UpdateFavoriteProductResponse,
} from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function updateFavoriteProduct(
  request: UpdateFavoriteProductRequest
): Promise<UpdateFavoriteProductResponse> {
  const res = await axiosInstance.post<UpdateFavoriteProductResponse>(
    api.updateFavoriteProduct,
    request
  );
  return res.data;
}

const useUpdateFavoriteProductMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: UpdateFavoriteProductResponse) => void;
  onError?: (error: Error) => void;
} = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: queryKeys.favorite.updateFavoriteProduct(),
    mutationFn: updateFavoriteProduct,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.favorite.root, 'shoppingList'],
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error as Error);
    },
  });

  return mutation;
};

export default useUpdateFavoriteProductMutation;
